import { action, atom } from '@reatom/framework'

import { DelugeId } from '@root/entities/user-short/model'
import { STORAGE_PREFIX } from '@root/shared'
import { ApiError } from '@root/shared/api'
import { apiErrorEvent } from '@root/shared/api/api-request'

import { User } from '../model'

import { authStateAtom } from './reatom-auth-state'

export const delugeIdAtom = authStateAtom.delugeId
export const isLoggedInAtom = authStateAtom.isLoggedIn

export const isAdminAtom = atom((ctx) => {
  const user = ctx.spy(userAtom)
  return user ? User.isAdmin(user) : false
}, 'isAdminAtom')

apiErrorEvent.onCall((ctx, _, [error]) => {
  if (ApiError.isUnauthorizedOrExpired(error)) {
    authStateAtom.setSessionExpired(ctx)
  }
})

export const userAtom = authStateAtom.user

export const userReferralStatusAtom = atom((ctx) => {
  const user = ctx.spy(userAtom)
  return user?.referralCodeStatus
}, 'userReferralStatusAtom')

export const isUserHypedAtom = atom((ctx) => {
  const userReferralStatus = ctx.spy(userReferralStatusAtom)
  return userReferralStatus === 'Hyped'
}, 'isUserHypedAtom')

const CACHED_DELUGE_ID_KEY = `${STORAGE_PREFIX}/cachedDelugeId`

export const getCachedDelugeId = () => {
  try {
    const rawDelugeId = localStorage.getItem(CACHED_DELUGE_ID_KEY)
    return rawDelugeId ? DelugeId(rawDelugeId) : undefined
  } catch {
    return undefined
  }
}

const cacheDelugeId = (delugeId: string) => {
  try {
    localStorage.setItem(CACHED_DELUGE_ID_KEY, delugeId)
  } catch {
    // ignore
  }
}

export const userReceivedAction = action((ctx, user: User.User) => {
  cacheDelugeId(user.delugeId)
  authStateAtom.updateUserOrSetLoggedIn(ctx, user)
}, 'userReceivedAction')

export const userSessionsAtom = atom((ctx) => {
  const user = ctx.spy(userAtom)
  return user?.sessions ?? []
}, 'userSessionsAtom')

export const mfaEnabledAtom = atom((ctx) => {
  const user = ctx.spy(userAtom)
  return user?.otpEnabled
}, 'mfaEnabledAtom')

export const otpQuickLoginEnabledAtom = atom((ctx) => {
  const user = ctx.spy(userAtom)
  return user?.otpQuickLoginEnabled
}, 'otpQuickLoginEnabledAtom')

export const incognitoModeEnabledAtom = atom((ctx) => {
  const user = ctx.spy(userAtom)
  return user?.isIncognito ?? false
}, 'incognitoModeEnabledAtom')

export const userFullNameAtom = atom((ctx) => {
  const user = ctx.spy(userAtom)
  return user ? User.fullName(user) : undefined
}, 'userFullNameAtom')

export const userFullNameOrUsernameAtom = atom((ctx) => {
  const user = ctx.spy(userAtom)
  const fullName = ctx.spy(userFullNameAtom)
  return fullName || user?.username
}, 'userFullNameOrUsernameAtom')

// eslint-disable-next-line @reatom/unit-naming-rule
export const redirectToAuthEvent = action<void>('redirectToAuthEvent')
